import { CCUtils } from "../../../../common/CCUtils"
import { PhaserUtils } from "../../../utils/PhaserUtils"
import { MakeVaperPart } from "../types/MakeYourOwnVaperTypes"
import { MakeVaperAgreement } from "./MakeYourOwnVaperPartTwoTypes"

export enum MakeVaperPt2Audio {
    INTRO = "make-your-vaper-p2-n1.mp3",
    YOUR_SPUD = "make-your-vaper-p2-n2.mp3",
    COMPARE_SPUD = "make-your-vaper-p2-n3.mp3",
    CLICK_NEXT = "make-your-vaper-p2-next.mp3",
    AGREE = "make-your-vaper-p2-n3-agree.mp3",
    DONT_AGREE = "make-your-vaper-p2-n3-dontagree.mp3",
    AGREEMENT = "make-your-vaper-p2-n4.mp3",
    ALREADY_AGREE = "make-your-vaper-p2-n5.mp3",
    DONT_AGREE_CHANGE = "make-your-vaper-p2-n7.mp3",
    NOW_AGREE = "make-your-vaper-p2-n8.mp3",
    STILL_DONT_AGREE = "make-your-vaper-p2-n9.mp3",
}

export const makeVaperPartTwoExitAudio = (agreement: MakeVaperAgreement) => `make-your-vaper-p2-outro${agreement + 1}.mp3`
export const makeVaperReviewPartAudio = (part: MakeVaperPart, type: "yes" | "no") => `make-your-vaper-p2-n2-${part}-${type}.mp3`
export const makeVaperClassmatesPartAudio = (part: MakeVaperPart) => `make-your-vaper-p2-n3-${part}.mp3`
export const makeVaperMostClassmatesAudio = (part: MakeVaperPart) => `make-your-vaper-p2-n6-${part}.mp3`

// tslint:disable-next-line
export function loadMakeVaperAssets(loader: {audio}) {
    CCUtils.enumValues(MakeVaperAgreement).forEach((agreement: MakeVaperAgreement) => {
        const audio = makeVaperPartTwoExitAudio(agreement)
        loader.audio(audio, audio)
    })
    
    CCUtils.enumValues(MakeVaperPart).forEach((part: MakeVaperPart) => {
        const yes = makeVaperReviewPartAudio(part, "yes")
        const no = makeVaperReviewPartAudio(part, "no")
        const classmates = makeVaperClassmatesPartAudio(part)
        const mostClassmates = makeVaperMostClassmatesAudio(part)
        loader.audio(yes, yes)
        loader.audio(no, no)
        loader.audio(classmates, classmates)
        loader.audio(mostClassmates, mostClassmates)
    })
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "make-vaper")
    load.autoLoad({audioEnum: MakeVaperPt2Audio})
    loadMakeVaperAssets(load)
}
